<h5 mat-dialog-title *ngIf="!filter" appLocalizationPopupDirective localizationCode="Filter-CreateAFilter">
    {{ 'Filter-CreateAFilter' | translate: {Default: "Create a Filter"} }} 
</h5>
<h5 mat-dialog-title *ngIf="filter" appLocalizationPopupDirective localizationCode="Filter-EditAFilter">
    {{ 'Filter-EditAFilter' | translate: {Default: "Edit a Filter"} }}
</h5>

<mat-dialog-content>
    <div class="form-container" [formGroup]="form">
        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="Filter-FilterCategory">
            <mat-label>
                {{ 'Filter-FilterCategory' | translate: {Default: "Filter Category"} }}
            </mat-label>
            
            <mat-select disableOptionCentering formControlName="filterCategory" (selectionChange)="operatorChange($event)">
                <mat-option *ngFor="let category of categories" [value]="category">{{category.title}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="Filter-FilterOperator">
            <mat-label>
                {{ 'Filter-FilterOperator' | translate: {Default: "Filter Operator"} }}
            </mat-label>
            
            <mat-select disableOptionCentering formControlName="filterOperator" >
                <mat-option *ngFor="let operator of operators[selectedCategory.dataType]" [value]="operator.value">{{operator.label}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="Filter-FilterValue">
            <mat-label>
                {{ 'Filter-FilterValue' | translate: {Default: "Filter Value"} }}
            </mat-label>

            <ng-container  *ngIf="selectedCategory.dataType == 'Date'">
                <input matInput [matDatepicker]="picker" formControlName="filterString">
                <mat-datepicker-toggle 
                    matSuffix 
                    [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </ng-container>

            <mat-select disableOptionCentering formControlName="filterString" *ngIf="selectedCategory.dataType == 'Boolean'" appLocalizationPopupDirective localizationCode="Filter-BooleanValue">
                <mat-option *ngFor="let option of booleanOptions" [value]="option.value">{{option.label}}</mat-option>
            </mat-select>

            <mat-select disableOptionCentering formControlName="filterString" *ngIf="selectedCategory.dataType == 'Lookup'" [attr.disabled]="isLoading" appLocalizationPopupDirective localizationCode="Filter-Search">
                <mat-form-field appearance="fill" class="dropdown-search">
                    <mat-label>
                      {{ 'Filter-Search' | translate: {Default: "Search"} }}
                    </mat-label>
                    <input matInput (keyup)="onDropdownSearchKeyReceived($event.target.value, filteredList)">
                  </mat-form-field>
                <mat-option *ngFor="let option of filteredList" [value]="option">{{option.text}}</mat-option>
            </mat-select>

            <mat-select disableOptionCentering formControlName="filterString" *ngIf="selectedCategory.dataType == 'ProvidedList'" appLocalizationPopupDirective localizationCode="Filter-Search">
                <mat-form-field appearance="fill" class="dropdown-search">
                    <mat-label>
                      {{ 'Filter-Search' | translate: {Default: "Search"} }}
                    </mat-label>
                    <input matInput (keyup)="onDropdownSearchKeyReceived($event.target.value, filteredList)">
                  </mat-form-field>
                <mat-option *ngFor="let providedListOption of providedList" [value]="providedListOption[providedListId]">{{providedListOption[providedListDisplayName]}}</mat-option>
            </mat-select>

            <mat-select disableOptionCentering formControlName="filterString" *ngIf="selectedCategory.dataType == 'SpecialLookup'" [attr.disabled]="isLoading" appLocalizationPopupDirective localizationCode="Filter-Search">
                <mat-form-field appearance="fill" class="dropdown-search">
                    <mat-label>
                      {{ 'Filter-Search' | translate: {Default: "Search"} }}
                    </mat-label>
                    <input matInput (keyup)="onDropdownSearchKeyReceived($event.target.value, filteredList)">
                  </mat-form-field>
                <mat-option *ngFor="let option of filteredList" [value]="option">{{option.name}}</mat-option>
            </mat-select>

            <ng-container *ngIf="selectedCategory.dataType == 'Percentage'">
                <div class="percentage-input">
                    <input matInput type="number" min="0" max="100" formControlName="filterString">
                    <span matSuffix>%</span>
                </div>
            </ng-container>

            <input *ngIf="selectedCategory.dataType == '' || selectedCategory.dataType == 'String' || selectedCategory.dataType == 'Number'" matInput formControlName="filterString">

        </mat-form-field>
    </div>

</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">
        {{ 'Close' | translate: {Default: "Close"} }}
    </button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">
        {{ 'Save' | translate: {Default: "Save"} }}
    </button>
</mat-dialog-actions>
